var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(0 -0.076)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect8872",
    width: 30,
    height: 30,
    transform: "translate(0 0.076)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M13.695,17.839A4.359,4.359,0,0,1,9.15,13.294,4.359,4.359,0,0,1,13.695,8.75a4.359,4.359,0,0,1,4.544,4.544,4.359,4.359,0,0,1-4.544,4.544ZM4,27.564V24.716a3.527,3.527,0,0,1,.53-1.909,3.414,3.414,0,0,1,1.53-1.3A22.2,22.2,0,0,1,10.1,20.111a16.166,16.166,0,0,1,3.59-.424h.7a4.713,4.713,0,0,0-.273.833,8.926,8.926,0,0,0-.151.985h-.273a15.6,15.6,0,0,0-3.439.379,15.724,15.724,0,0,0-3.469,1.257,1.643,1.643,0,0,0-.727.682,1.831,1.831,0,0,0-.242.894v1.03h8.15a5.89,5.89,0,0,0,.364.985,4.752,4.752,0,0,0,.515.833ZM21.784,28.9l-.3-2a5.375,5.375,0,0,1-1.045-.439,3.851,3.851,0,0,1-.894-.651l-1.666.364L17.118,24.9l1.424-1.333a4.764,4.764,0,0,1,0-1.515l-1.424-1.333.757-1.272,1.666.364a3.851,3.851,0,0,1,.894-.651,5.375,5.375,0,0,1,1.045-.439l.3-2H23.42l.3,2a5.375,5.375,0,0,1,1.045.439,3.851,3.851,0,0,1,.894.651l1.666-.364.757,1.272L26.662,22.05a4.764,4.764,0,0,1,0,1.515L28.086,24.9l-.757,1.272-1.666-.364a3.851,3.851,0,0,1-.894.651,5.375,5.375,0,0,1-1.045.439l-.3,2Zm.818-3.666a2.29,2.29,0,1,0-1.757-.667A2.376,2.376,0,0,0,22.6,25.231Zm-8.907-9.21a2.642,2.642,0,0,0,2.727-2.727,2.642,2.642,0,0,0-2.727-2.727,2.642,2.642,0,0,0-2.727,2.727,2.642,2.642,0,0,0,2.727,2.727ZM13.695,13.294ZM13.968,25.746Z",
    transform: "translate(-0.578 -3.669)",
    fill: "rgba(0,0,0,0.6)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.95bc5338ff6e3f7a573a84395ac4e8a2.svg";
export { ForwardRef as ReactComponent };